<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            text
            @click="
              (showNachricht = true) &&
                (neuNachricht = true) &&
                (nachricht = { an: [], absenderPosition: '', message: {}, absender: {} })
            "
            v-on="on"
            ><v-icon>add</v-icon>Neue Mail</v-btn
          >
        </template>
        <span>Neue Mail</span>
      </v-tooltip>
      <!-- <v-btn v-if="$vars.beta" @click="test()">GetMails</v-btn> -->
      <v-menu offset-y max-width="500">
        <template v-slot:activator="{ on, attrs }">
          <v-card v-if="versand.length > 0" class="rounded-lg" outlined width="250px" v-on="on">
            <v-progress-linear indeterminate height="24" class="caption">
              {{ versand.length }} Nachrichten im Postausgang
              <v-btn icon @click="showVersandMenu = true"><v-icon>info</v-icon></v-btn>
            </v-progress-linear>
          </v-card>
        </template>
        <v-list dense>
          <v-list-item>
            <v-btn @click="alleErneutVersenden()">Alle versenden</v-btn>
            <span class="text-subtitle-2 px-4">Alle 5 Sekunden wird eine Mail versendet. Seite nicht schließen.</span>
          </v-list-item>
          <v-list-item v-for="(item, index) in versand" :key="index">
            <v-list-item-icon>
              <v-progress-circular indeterminate></v-progress-circular>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>
                {{ $filters.date(item.datum.seconds * 1000, "TDD.MM.YYYY hh:mm") }} Uhr |
                {{ item.id }}</v-list-item-subtitle
              >
              <v-list-item-title>{{ item.message.subject }}</v-list-item-title>
              <v-list-item-subtitle>
                An:
                <v-chip label small v-for="(bbr, index2) in item.an" :key="index2">
                  {{ $filters.user(bbr, bundesbruder) }}
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="erneutVersenden(item)"><v-icon>forward_to_inbox</v-icon></v-btn>
                </template>
                <span>Scheinbar gibt es ein Problem beim Versenden der Mail. E-Mail erneut senden.</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-subheader class="mt-2">
            Der Mailversand kann unter Umständen mehrere Minuten dauern. Sollte eine Mail auch nach längerer Zeit im
            Postausgang sein, kannst du den Versand erneut anstoßen.
          </v-subheader>
        </v-list>
      </v-menu>

      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Suchen"
          single-line
          solo
          flat
          hide-details
          clearable
          clear-icon="close"
        ></v-text-field>
      </v-toolbar-items>
      <v-chip small label color="green" dark>BETA</v-chip>
    </v-toolbar>
    <v-divider></v-divider>

    <!-- ***************************************************************** 

Tabelle mit Nachrichten

***************************************************************** -->
    <v-row no-gutters>
      <v-col cols="12" md="4">
        <v-card class="ma-2 rounded-t-lg pt-1" outlined>
          <v-card-title class="pa-0">
            <v-tabs grow v-model="filter">
              <v-tab>Eingang</v-tab>
              <v-tab>Gesendet</v-tab>
            </v-tabs>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0" ref="card">
            <v-virtual-scroll :items="nachrichten" :height="cardHeight" item-height="68">
              <template v-slot:default="{ item, index }">
                <v-list-item
                  @click="
                    nachricht = item;
                    handleResize();
                  "
                >
                  <v-list-item-action v-if="item.status === 'Error' && item.status">
                    <v-icon color="red">warning</v-icon>
                  </v-list-item-action>
                  <!-- <v-list-item-action v-if="((item.bcc.length + (item.an.length > 0 || item.cc.length > 0) ? 1 : 0) - ( item.log.filter(item => item.status.includes('Versendet')).length) > 0)">
                    <v-progress-circular color="primary" :value="100 * (1 - ((item.bcc.length + (item.an.length > 0 || item.cc.length > 0) ? 1 : 0) - ( item.log.filter(item => item.status.includes('Versendet')).length)) / (item.bcc.length + 1))" rotate="-90">
                      {{ ((item.bcc.length + (item.an.length > 0 || item.cc.length > 0) ? 1 : 0) - ( item.log.filter(item => item.status.includes('Versendet')).length)) }}
                    </v-progress-circular>
                  </v-list-item-action> -->
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      <span v-if="item.absender.position">{{ item.absender.position }}</span>
                      <span v-if="item.absender.name">{{ item.absender.name }}</span>
                      <span v-if="item.von">{{ $filters.user(item.von, bundesbruder) }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.message.subject }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="text-right">
                    {{ $filters.date(item.datum.seconds * 1000, "DD.MM.YYYY") }}<br />
                    {{ $filters.date(item.datum.seconds * 1000, "hh:mm Uhr") }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
              </template>
            </v-virtual-scroll>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="8" class="hidden-xs-only pa-2">
        <v-card outlined :height="cardHeight + 55" v-if="nachricht.id" class="rounded-t-lg">
          <v-card-title class="pa-2 pl-4">
            {{ nachricht.message.subject }}
            <v-spacer></v-spacer>
            <v-chip label small v-if="nachricht.status">{{ nachricht.status }}</v-chip>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-title class="pa-2 pl-4 subtitle-2">
            <span v-if="nachricht.datum">{{
              $filters.date(nachricht.datum.seconds * 1000, "DD.MM.YYYY um hh:mm Uhr")
            }}</span>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="duplicateMail(nachricht)" v-on="on"><v-icon>content_copy</v-icon></v-btn>
              </template>
              <span>Mail duplizieren</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="deleteMail(nachricht.id)" v-on="on"><v-icon>delete</v-icon></v-btn>
              </template>
              <span>Mail direkt Löschen</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="erneutVersenden(nachricht)" v-on="on"><v-icon>outgoing_mail</v-icon></v-btn>
              </template>
              <span
                >Erneut senden<br /><br />Die Mail wird ohne bestätigung direkt erneut an die gleichen Empfänger
                gesendet</span
              >
            </v-tooltip>
            <v-btn
              icon
              @click="
                showNachrichtenInfo = true;
                getAnalytics();
              "
            >
              <v-icon>insights</v-icon>
            </v-btn>
            <v-dialog persistent v-model="showNachrichtenInfo" width="80%" scrollable>
              <v-card rounded="xl" min-height="300px">
                <v-card-title>
                  Nachrichten-Log
                  <v-spacer></v-spacer>

                  <v-btn icon :loading="loading.mailAnalytics" @click="getAnalytics()">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                  <v-btn icon @click="showNachrichtenInfo = false"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-title>
                  <v-row>
                    <v-col cols="12">
                      <div class="d-flex flex-wrap justify-space-around align-center">
                        <div
                          v-for="(item, key, index) in stats"
                          :key="index"
                          class="d-flex flex-column align-center mx-4 my-2"
                        >
                          <!-- Fortschrittsanzeige -->
                          <v-progress-circular
                            :value="(item.value / totalRecipients) * 100"
                            :color="item.color"
                            size="80"
                            width="8"
                            rotate="-90"
                            :indeterminate="loading.mailAnalytics"
                          >
                            <strong>{{ Math.round((item.value / totalRecipients) * 100) }}%</strong>
                          </v-progress-circular>

                          <!-- Label und Details -->
                          <div class="text-center mt-2">
                            <strong>{{ item.label }}</strong>
                            <div>{{ item.value }} von {{ totalRecipients }}</div>
                          </div>

                          <!-- Tooltip für zusätzliche Infos -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon x-small v-on="on" class="mt-1">
                                <v-icon small>help_outline</v-icon>
                              </v-btn>
                            </template>
                            <v-card flat class="transparent" dark width="200px">
                              {{ item.hint }}
                            </v-card>
                          </v-tooltip>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <span v-if="mailErrors(nachricht.log).length > 0">
                    <v-divider></v-divider>
                    <pre>{{ nachricht.log }}</pre>
                  </span>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="subtitle-2 pa-2">
            Von:
            <span v-if="nachricht.absender">
              <span v-if="nachricht.absender.position">{{ nachricht.absender.position }}</span>
              <span v-if="nachricht.absender.name">{{ nachricht.absender.name }}</span>
            </span>
            <span v-if="nachricht.von">{{ $filters.user(nachricht.von, bundesbruder) }}</span>
            <div v-if="nachricht.an" class="mt-1">
              An:
              <v-chip label class="mr-1" small v-for="(item2, index2) in nachricht.gruppen" :key="index2 * 2">
                <v-avatar left><v-icon>group</v-icon></v-avatar>
                {{ item2 }}
              </v-chip>
              <v-chip pill class="mr-1" small v-for="(item, index) in nachricht.an" :key="index * 2 + 1">
                <v-avatar left><v-icon>account_circle</v-icon></v-avatar>
                {{ $filters.user(item, bundesbruder) }}
              </v-chip>
              <v-chip pill class="mr-1" small v-for="(item, index) in nachricht.an_adresse" :key="index * 2 + 1">
                {{ item }}
              </v-chip>
            </div>
            <div v-if="nachricht.an_cc && nachricht.an_cc.length > 0" class="mt-1">
              CC:
              <v-chip pill class="mr-1" small v-for="(item, index) in nachricht.an_cc" :key="index">
                <v-avatar left><v-icon>account_circle</v-icon></v-avatar>
                {{ $filters.user(item, bundesbruder) }}
              </v-chip>
            </div>
            <div v-if="nachricht.an_bcc && nachricht.an_bcc.length > 0" class="mt-1">
              BCC:
              <v-chip pill class="mr-1" small v-for="(item, index) in nachricht.an_bcc" :key="index">
                <v-avatar left><v-icon>account_circle</v-icon></v-avatar>
                {{ $filters.user(item, bundesbruder) }}
              </v-chip>
            </div>
            <div v-if="nachricht.attachments && nachricht.attachments.length > 0" class="mt-1">
              Anhang:
              <v-chip
                label
                class="mr-1"
                small
                v-for="(item, index) in nachricht.attachments"
                :key="index"
                :href="item.path"
                target="_blank"
              >
                <v-avatar left><v-icon small>attach_file</v-icon></v-avatar>
                {{ item.filename }}
              </v-chip>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="ma-0 pa-0">
            <v-sheet
              ref="cardText"
              class="pa-4"
              style="overflow-y: auto"
              :max-height="sheetHeight"
              v-html="nachricht.message.html"
            ></v-sheet>
          </v-card-text>
        </v-card>
        <v-card v-else outlined class="rounded-lg pt-1">
          <v-subheader>Nachricht auswählen</v-subheader>
        </v-card>
      </v-col>
    </v-row>
    <dialogMailNeu
      :visible.sync="showNachricht"
      :copynachricht="nachricht"
      @close="showNachricht = false"
    ></dialogMailNeu>
  </v-container>
</template>

<script>
  import korpodeskApi from "@/services/korpodeskApi";

  export default {
    data() {
      return {
        emails: [],
        search: "",
        filter: null,
        showNachricht: false,
        showNachrichtenInfo: false,
        showOnlyError: true,
        loading: {
          mailAnalytics: false,
          stats: false,
        },
        neuNachricht: false,
        showVersandMenu: false,
        response: "",
        headers: [{ text: "Betreff", align: "left", value: "betreff" }],
        nachricht: {
          an: [],
          cc: [],
          bcc: [],
          gruppen: [],
          message: {},
          absender: {},
        },
        stats: null,
        fehler: null,
        cardHeight: 0,
        sheetHeight: 500,
      };
    },
    async mounted() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.handleResize);
    },
    computed: {
      bundesbruder() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      nachrichten() {
        if (this.$store.state.mails.loaded === false) {
          this.$store.dispatch("mails/loadMails");
        }
        if (this.filter === 0) {
          return this.$store.getters["mails/eigeneMails"](this.currentBbr);
        } else {
          return this.$store.getters["mails/gesendeteMails"](this.currentBbr);
        }
      },
      versand() {
        if (this.$store.state.mails.loaded) {
          return this.$store.getters["mails/entwurfAndErrorMails"];
        }
      },
      totalRecipients() {
        return this.nachricht.to.length + this.nachricht.cc.length + this.nachricht.bcc.length || 1;
      },
    },
    methods: {
      async getAnalytics() {
        this.loading.mailAnalytics = true;
        try {
          const today = Math.floor(Date.now() / 1000); // Aktueller Timestamp in Sekunden
          const sixMonthsAgo = today - 6 * 30 * 24 * 60 * 60; // 6 Monate zurück
          const res = await this.$firebase.functions().httpsCallable("getAnalytics")({
            domain_id: "xkjn41m20j54z781",
            from: sixMonthsAgo,
            to: today,
            group: "years",
            tags: [this.nachricht.id],
          });
          const data = res.data.body.data.stats.reduce((acc, curr) => {
            Object.keys(curr).forEach((key) => {
              if (key !== "date") {
                // ⏱️ Datum nicht summieren
                acc[key] = (acc[key] || 0) + curr[key];
              }
            });
            return acc;
          }, {});

          this.stats = [
            // {
            //   label: "Queued",
            //   value: data.queued,
            //   color: "green",
            //   hint: "Die Mail wurde in die Warteschlange gestellt und wird in Kürze versendet.",
            // },
            {
              label: "Versendet",
              value: data.sent,
              color: "green",
              hint: "Die Mail wurde erfolgreich versendet. Das heißt noch nicht, dass sie auch angekommen ist.",
            },
            {
              label: "Zugestellt",
              value: data.delivered,
              color: "green",
              hint: "Die Mail wurde erfolgreich zugestellt.",
            },
            {
              label: "Soft Bounced",
              value: data.soft_bounced,
              color: "orange",
              hint: "Die Mail konnte nicht zugestellt werden, weil der Empfänger-Server die Mail abgelehng hat. Das kann an temporären Problemen wie z.B. einem vollen Postfach oder einer falschen Adresse liegen. Eventuell wurde die Mail auch als Spam markiert.",
            },
            {
              label: "Hard Bounced",
              value: data.hard_bounced,
              color: "red",
              hint: "Die Mail konnte nicht zugestellt werden und wird nicht erneut versucht.",
            },
            {
              label: "Geöffnet",
              value: data.opened,
              color: "green",
              hint: "Die Mail wurde geöffnet. Die Zahl kann über der Gesamtzahl liegen, da ein Empfänger mehrfach öffnen kann.",
            },
            // {
            //   label: "Clicked",
            //   value: data.clicked,
            //   color: "green",
            //   hint: "Ein Link in der Mail wurde angeklickt. Die Zahl kann über der Gesamtzahl liegen, da ein Empfänger mehrfach klicken kann.",
            // },
            // {
            //   label: "Unsubscribed",
            //   value: data.unsubscribed,
            //   color: "orange",
            //   hint: "Der Empfänger hat sich vom Newsletter abgemeldet.",
            // },
            // {
            //   label: "Spam Complaints",
            //   value: data.spam_complaints,
            //   color: "red",
            //   hint: "Die Mail wurde als Spam markiert.",
            // },
          ];
          this.loading.mailAnalytics = false;
          return;
        } catch (error) {
          console.log(error);
          this.loading.mailAnalytics = false;
          return;
        }
      },
      async getEmailStats(email) {
        try {
          this.loading.stats = true;

          // 📡 API-Aufruf mit Parametern
          const endpoint = `/api/v1/email/getEmailStats?bulk_email_id=${email.bulk_email_id}&email_id=${email.id}`;

          const response = await korpodeskApi.request(endpoint, "GET");

          console.log("📊 E-Mail-Statistik:", response);

          if (response.success) {
            this.stats = { ...response.data };
          } else {
            this.fehler = response.error || "Unbekannter Fehler beim Abrufen der Statistiken.";
            console.error("❌ Fehler beim Abrufen der Stats:", this.fehler);
          }
        } catch (error) {
          this.fehler = error.message || "Ein unerwarteter Fehler ist aufgetreten.";
          console.error("❌ API-Fehler:", error);
        } finally {
          this.loading.stats = false;
        }
      },
      mailErrors(log) {
        const errormails = [];
        if (log && Array.isArray(log)) {
          log.forEach((item) => {
            if (item.error) {
              errormails.push(...item.recipients);
            }
          });
        }
        const uniqueEmails = [...new Set(errormails)];
        const finalEmails = [];
        uniqueEmails.forEach((mail) => {
          let kontakt = this.bundesbruder.find((kontakt) => kontakt.email === mail);
          if (kontakt) {
            finalEmails.push({ kontakt: kontakt.id, mail });
          } else {
            finalEmails.push({ kontakt: mail, mail });
          }
        });
        return finalEmails;
      },
      test() {
        console.log("GetMails()");
      },
      duplicateMail(item) {
        this.copynachricht = item;
        console.log(this.copynachricht);
        this.showNachricht = true;
        this.neuNachricht = true;
      },
      handleResize() {
        this.cardHeight = window.innerHeight - this.$refs.card.offsetTop - 186;
        if (this.nachricht.id && this.$refs.cardText) {
          this.sheetHeight = window.innerHeight - this.$refs.cardText.$el.offsetTop - 186;
        }
      },
      alleErneutVersenden() {
        const length = this.versand.length;
        this.versand.forEach((item, index) => {
          setTimeout(() => {
            console.log("send Mail (" + (index + 1) + "/" + length + ")");
            this.erneutVersenden(item);
          }, 5000 * index);
        });
      },
      erneutVersenden(mail) {
        mail.datum = new Date();
        mail.status = "Warte auf Versand..";
        mail.queue = mail.bcc ? mail.bcc.length + 1 : 1;
        this.$store.dispatch("mails/createEinMails", mail);
        this.$store.state.snackbar = {
          show: true,
          nachricht: "Mail wurde für den Versand übermittelt. Der Versand kann mehrere Minuten dauern.",
        };
        this.deleteMail(mail.id);
      },
      deleteMail(id) {
        this.nachricht = {
          an: [],
          message: {},
          absender: {},
        };
        this.$store.dispatch("mails/deleteEinMailsData", id);
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// mail.vue?47ff7742